import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Contact from "../components/Contact";
import Whatsapp from "../components/util/Whatsapp";
import Perguntas from "../components/Perguntas";
import { Faixa, Cabecalho, fundosAlternados } from "../components/Faixa";
import { grupos } from "../components/data/perguntas";
import { whatsappUrl } from "../components/util/whatsappUrl";
import { trackWhatsapp } from "../components/util/analytics";

const titulo = "Perguntas frequentes | Hawx Soluções";

const Faq = () => {
  useEffect(() => {
    const anterior = document.title;
    document.title = titulo;
    return () => {
      document.title = anterior;
    };
  }, []);

  const fundos = fundosAlternados(grupos.length);
  const fundoFinal = fundos[fundos.length - 1];

  return (
    <>
      <Header />
      <main>
        <div className="bg-pattern-gradient pt-12 xl:pb-32">
          <div className="text-white w-3/4 mx-auto xl:pt-48 pt-24 pb-16 xl:text-center">
            <h1 className="text-4xl sm:text-5xl xl:text-6xl font-semibold leading-[1.1] mb-8">
              {"Perguntas "}
              <strong className="text-gradient">frequentes</strong>
            </h1>
            <p className="text-xl xl:text-2xl leading-relaxed mb-10 xl:w-2/3 xl:mx-auto">
              O que as empresas perguntam antes de contratar a Hawx: onde atendemos, como um projeto começa, quanto custa e o que acontece depois da entrega.
            </p>
            <a
              href={whatsappUrl("Olá! Vi as perguntas frequentes no site da Hawx e quero tirar uma dúvida.")}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsapp("pagina-perguntas-frequentes")}
              className="btn-glass font-semibold py-6 px-8 rounded-full block xl:inline-block text-xl text-center w-full xl:w-auto"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>

        {grupos.map((grupo, indice) => (
          <Faixa key={grupo.rotulo} fundo={fundos[indice]} anterior={indice === 0 ? "white" : fundos[indice - 1]} proximo={fundos[indice + 1] || "contato"}>
            <Cabecalho rotulo={grupo.rotulo} titulo={grupo.titulo} />
            <Perguntas perguntas={grupo.perguntas} />
          </Faixa>
        ))}
      </main>
      <Contact fundoAnterior={fundoFinal} />
      <Whatsapp />
      <Footer />
    </>
  );
};

export default Faq;
